import React, { useState, useEffect } from 'react';
import * as api from '~/Services/Service';
import { toast } from 'react-toastify';
import 'bootstrap/dist/css/bootstrap.min.css';
import { default as Selector } from 'react-select';
import Loading from '~/Components/Loading';
import './painelRmm.css';

function painelRmm() {
  const [mensagem, setMensagem] = useState('');
  const [mensagemSite, setMensagemSite] = useState('');
  const [hostname, setHostname] = useState('');
  const [hosts, setHosts] = useState([]);
  const [hostsFiltrados, setHostsFiltrados] = useState([]);
  const [sitesFiltrados, setSitesFiltrados] = useState([]);
  const [siteMap, setSiteMap] = useState(new Map());
  const [siteSelecionado, setSiteSelecionado] = useState('');
  const [clients, setClients] = useState([]);
  const [clientSelecionado, setClientSelecionado] = useState('');
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const carregarDadosIniciais = async () => {
      try {
        setLoading(true);
        const response = await api.BuscarClientesPainelRmm();
        setClients(response);
      } catch (err) {
        console.error(err);
        toast.error('Erro ao carregar clients');
      } finally {
        setLoading(false);
      }
    };

    carregarDadosIniciais();
  }, []);

  useEffect(() => {
    const carregarHostsPorClient = async () => {
      if (!clientSelecionado) return;
      try {
        const response = await api.BuscarHosts(clientSelecionado);
        const responseObj = JSON.parse(response);
        if (responseObj.length === 0) {
          setHosts([]);
          setHostsFiltrados([]);
          throw new Error('Nenhum agente encontrado para essa localidade');
        }
        const hosts = responseObj
          .sort((a, b) => {
            const siteA = (a.site_name || '').toLowerCase();
            const siteB = (b.site_name || '').toLowerCase();
            return siteA.localeCompare(siteB);
          })
          .map(agent => ({
            label: `${agent.hostname} - ${agent.site_name || 'Sem site'}`,
            value: agent.agent_id,
            client: agent.client,
            site: agent.site,
            site_name: agent.site_name,
            hostname: agent.hostname,
            sites: agent.sites,
          }));

        setHosts(hosts);
        setHostsFiltrados(hosts);
      } catch (err) {
        toast.error(err.message);
        console.error(err);
      }
    };

    carregarHostsPorClient();
  }, [clientSelecionado]);

  useEffect(() => {
    if (!clientSelecionado) {
      setSitesFiltrados([]);
      return;
    }
    const client = clients.find(item => item.id === clientSelecionado);
    const sitesDoClient =
      client && client.sites
        ? client.sites.map(site => ({ id: site.id, nome: site.name }))
        : [];

    setSitesFiltrados(sitesDoClient);
  }, [clientSelecionado]);

  const enviarMensagem = async () => {
    if (!mensagem) return toast.warning('Preencha o campo de mensagem.');

    try {
      let request = { mensagem: mensagem, id: hostname };
      await api.EnviarMensagemParaHost(request);
      toast.success('Mensagem enviada com sucesso!');
    } catch (err) {
      toast.error('Erro ao enviar mensagem');
      console.error('Erro:', err);
    }
  };

  const clientOptions = clients.map(c => ({ value: c.id, label: c.name }));
  const selectedClient = clientOptions.find(
    c => c.value.toString() === clientSelecionado
  );

  const selectedHost = hostsFiltrados.find(h => h.value === hostname);

  const siteOptions = sitesFiltrados.map(s => ({
    value: s.id,
    label: s.nome,
  }));
  const selectedSite = siteOptions.find(s => s.value === siteSelecionado);

  if (loading) {
    return <Loading />;
  }

  return (
    <>
      <div className="container mt-5 painel-rmm-container">
        <div className="text-center mb-5">
          <h3>Painel de Controle RMM</h3>
          <p className="">Envio de mensagens e comandos para agentes</p>
        </div>

        <div className="row ">
          <div className="col-12 mb-4">
            <div className="card shadow-sm">
              <div className="card-header">
                <h6 className="mb-0">1. Selecione a Localidade</h6>
              </div>
              <div className="card-body">
                <Selector
                  value={selectedClient}
                  onChange={option =>
                    setClientSelecionado(option ? option.value : '')
                  }
                  options={clientOptions}
                  placeholder="Selecione a localidade"
                  isClearable
                />

                {clientSelecionado && (
                  <div className="mt-3 alert alert-info">
                    <strong>Localidade selecionada:</strong>{' '}
                    {
                      (
                        clients.find(
                          c => c.id.toString() === clientSelecionado
                        ) || {}
                      ).name
                    }
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>

        {
          <div className="row">
            <div className="col-12 mb-4">
              <div className="card shadow-sm">
                <div className="card-header">
                  <h6 className="mb-0">2. Mensagem para Agente Individual</h6>
                </div>
                <div className="card-body d-flex flex-column">
                  <div className="mb-3">
                    <label className="form-label">Selecionar agente</label>
                    <Selector
                      options={hostsFiltrados}
                      value={selectedHost}
                      onChange={option =>
                        setHostname(option ? option.value : '')
                      }
                      placeholder="Selecione um agente"
                      isClearable
                    />
                  </div>

                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Mensagem</label>
                    <textarea
                      className="form-control h-100"
                      rows="4"
                      placeholder="Digite a mensagem"
                      value={mensagem}
                      onChange={e => setMensagem(e.target.value)}
                    />
                  </div>

                  <button
                    className="btn btn-primary mt-auto"
                    onClick={enviarMensagem}
                  >
                    Enviar mensagem para o agente
                  </button>
                </div>
              </div>
            </div>

            <div className="col-12 mb-4">
              <div className="card shadow-sm">
                <div className="card-header">
                  <h6 className="mb-0">3. Mensagem por Departamento</h6>
                </div>
                <div className="card-body d-flex flex-column">
                  <div className="mb-3">
                    <label className="form-label">
                      Selecionar departamento
                    </label>
                    <Selector
                      options={siteOptions}
                      value={selectedSite}
                      onChange={option =>
                        setSiteSelecionado(option ? option.value : '')
                      }
                      placeholder="Selecione um departamento"
                      isClearable
                    />
                  </div>

                  <div className="mb-3 flex-grow-1">
                    <label className="form-label">Mensagem</label>
                    <textarea
                      className="form-control h-100"
                      rows="4"
                      placeholder="Digite a mensagem"
                      value={mensagemSite}
                      onChange={e => setMensagemSite(e.target.value)}
                    />
                  </div>

                  <button
                    className="btn btn-success mt-auto"
                    onClick={async () => {
                      if (!mensagemSite || !siteSelecionado)
                        return toast.alert('Preencha a mensagem e o site.');
                      try {
                        let request = {
                          mensagem: mensagemSite,
                          id: siteSelecionado,
                        };
                        await api.EnviarMensagemParaSite(request);
                        toast.success(
                          'Mensagem enviada para o site com sucesso!'
                        );
                      } catch (err) {
                        toast.error('Erro ao enviar mensagem para site');
                        console.error(err);
                      }
                    }}
                  >
                    Enviar mensagem para o departamento
                  </button>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    </>
  );
}

export default painelRmm;
